// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"dfddba88","34":"015737d7","122":"476f3ea6","532":"d4783aa0","603":"7626340e","920":"6d2596fb"}[chunkId] + ".chunk.js";
};